var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.20001C1.60218 3.20001 1.22064 3.04198 0.93934 2.76067C0.658035 2.47937 0.5 2.09784 0.5 1.70001C0.5 1.30219 0.658035 0.920657 0.93934 0.639352C1.22064 0.358047 1.60218 0.200012 2 0.200012C2.39782 0.200012 2.77936 0.358047 3.06066 0.639352C3.34196 0.920657 3.5 1.30219 3.5 1.70001C3.5 2.09784 3.34196 2.47937 3.06066 2.76067C2.77936 3.04198 2.39782 3.20001 2 3.20001V3.20001Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.5C1.60218 9.5 1.22064 9.34196 0.93934 9.06066C0.658035 8.77936 0.5 8.39782 0.5 8C0.5 7.60218 0.658035 7.22064 0.93934 6.93934C1.22064 6.65804 1.60218 6.5 2 6.5C2.39782 6.5 2.77936 6.65804 3.06066 6.93934C3.34196 7.22064 3.5 7.60218 3.5 8C3.5 8.39782 3.34196 8.77936 3.06066 9.06066C2.77936 9.34196 2.39782 9.5 2 9.5Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.3C0.5 14.6978 0.658035 15.0794 0.93934 15.3607C1.22064 15.642 1.60218 15.8 2 15.8C2.39782 15.8 2.77936 15.642 3.06066 15.3607C3.34196 15.0794 3.5 14.6978 3.5 14.3C3.5 13.9022 3.34196 13.5207 3.06066 13.2394C2.77936 12.9581 2.39782 12.8 2 12.8C1.60218 12.8 1.22064 12.9581 0.93934 13.2394C0.658035 13.5207 0.5 13.9022 0.5 14.3V14.3Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.3d56b097dbb2a7265c45c8936946ec8f.svg";
export { ForwardRef as ReactComponent };